<nb-card [nbSpinner]="loading" nbSpinnerSize="giant" nbSpinnerStatus="primary" class="card-scroll">
	<nb-card-header>
		<h4>
			<ngx-header-title [allowEmployee]="false">
				{{ 'REPORT_PAGE.ALL_REPORTS' | translate }}
			</ngx-header-title>
		</h4>
	</nb-card-header>
	<nb-card-body>
		<div *ngFor="let reportCategory of reportCategories">
			<div class="mb-4 mt-5">
				<h5>
					<span class="category-icon mr-2">
						<i class="fa {{ reportCategory.iconClass }}"></i>
					</span>
					{{ reportCategory.name }}
				</h5>
			</div>
			<div class="card-grid">
				<a
					[routerLink]="['/pages/reports', report.slug]"
					class="mb-0 card"
					*ngFor="let report of reportCategory.reports"
				>
					<nb-card class="border-0 m-0">
						<nb-card-header>
							<div class="row align-items-center">
								<h6 class="col">{{ report?.name }}</h6>
								<div class="col-auto">
									<nb-toggle
										(click)="$event.stopPropagation()"
										[(ngModel)]="report.showInMenu"
										(checkedChange)="
											updateShowInMenu($event, report)
										"
									></nb-toggle>
								</div>
							</div>
						</nb-card-header>
						<nb-card-body>
							<div class="caption">{{ report?.description }}</div>
							<div
								class="image-container"
								*ngIf="report.imageUrl"
							>
								<img [src]="report.imageUrl" />
							</div>
						</nb-card-body>
					</nb-card>
				</a>
			</div>
		</div>
	</nb-card-body>
</nb-card>
